const Divider = ({ className }) => {
  const classes = ['divider']
  if (className) classes.push(className)
  return <div className={classes.join(' ')} />
}

export default Divider
